import { formatDecimal, displayValuationAmount } from "./inventory-format";

export function ValuationAmount({ value, currency, t, emptyLabel, incomplete }) {
  const formatted = formatDecimal(displayValuationAmount(value, { incomplete }));
  if (formatted === null) {
    return <span className="font-medium text-amber-800">{t(emptyLabel || "inventoryValuation.missingCost")}</span>;
  }
  return <span>{formatted} {currency || "NOK"}</span>;
}
